import styles from './second.module.css';
import FullSize from '../../components/full-size';
import { useNavigate } from 'react-router-dom';
import { getNextLevelUrl, isLevelAllowed, markLevelCompleted } from '../../helper';
import { useEffect, useState, useRef } from 'react';
import HintBox from '../../components/hint-box';
import Button from '../../components/button';
import clsx from 'clsx';

function Second() {
  const LEVEL = 2;
  const navigate = useNavigate();
  const [c, setC] = useState('');
  const [m, setM] = useState('');
  const [y, setY] = useState('');
  const [k, setK] = useState('');
  const [shake, setShake] = useState(false);
  
  const mRef = useRef<HTMLInputElement>(null);
  const yRef = useRef<HTMLInputElement>(null);
  const kRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!isLevelAllowed(LEVEL)) {
      navigate("/cheating");
    }
  }, [navigate])

  const allFilled = c && m && y && k;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const answer = `${c}${m}${y}${k}`;
    if (answer.toLowerCase() === "3211" || answer.toLowerCase() === "9898") {
      markLevelCompleted(LEVEL);
      navigate(getNextLevelUrl(LEVEL));
    } else {
      setShake(true);
    }
  }

  return (
    <FullSize bgColor="transparent">
      <form onSubmit={handleSubmit} className={clsx(styles.wrapper, { [styles.shake]: shake })}>
        <h1 className={styles.title}>Level 2</h1>
        <div className={styles.columns}>
          <div className={styles.column}>
            <label className={styles.label}>C</label>
            <input
              type="number"
              value={c}
              onChange={(e) => {
                const newValue = e.target.value;
                setShake(false);
                setC(newValue);
                if (newValue.length === 1 && c.length === 0) {
                  mRef.current?.focus();
                }
              }}
              className={styles.input}
            />
          </div>
          <div className={styles.column}>
            <label className={styles.label}>M</label>
            <input
              ref={mRef}
              type="number"
              maxLength={1}
              value={m}
              onChange={(e) => {
                const newValue = e.target.value;
                setShake(false);
                setM(newValue);
                if (newValue.length === 1 && m.length === 0) {
                  yRef.current?.focus();
                }
              }}
              className={styles.input}
            />
          </div>
          <div className={styles.column}>
            <label className={styles.label}>Y</label>
            <input
              ref={yRef}
              type="number"
              maxLength={1}
              value={y}
              onChange={(e) => {
                const newValue = e.target.value;
                setShake(false);
                setY(newValue);
                if (newValue.length === 1 && y.length === 0) {
                  kRef.current?.focus();
                }
              }}
              className={styles.input}
            />
          </div>
          <div className={styles.column}>
            <label className={styles.label}>K</label>
            <input
              ref={kRef}
              type="number"
              maxLength={1}
              value={k}
              onChange={(e) => {
                setShake(false);
                setK(e.target.value);
              }}
              className={styles.input}
            />
          </div>
        </div>
        <Button type="submit" disabled={!allFilled}>Skicka</Button>
      </form>
      <HintBox hintText="Upp och hoppa. Sök efter färgskalan i verkligheten." />
    </FullSize>
  );
}

export default Second;
